import useSWR from 'swr';
import axiosInstance from 'apis/axiosInstance';
import { loadSelectedClinicId } from 'utils/storage';
import { OnlineSchedulingParams } from 'interfaces/onlineSchedulingParams';

export interface OpenedWidgetPeriodData {
  totalOpenedWidget: number;
  period: {
    startDate: string;
    endDate: string;
  };
}

export interface RoiOpenedWidgetData {
  lastPeriodData: OpenedWidgetPeriodData;
  periodData: OpenedWidgetPeriodData;
}

const useRoiOpenedWidget = (params: OnlineSchedulingParams) => {
  const storedId = loadSelectedClinicId();
  const clinicIds = params.clinicIds ?? [storedId];
  const headerClinicId = storedId || clinicIds[0];
  const query =
    params.startDate && params.endDate
      ? new URLSearchParams({
          startDate: params.startDate,
          endDate: params.endDate,
          hourType: params.hourType,
        }).toString()
      : '';

  const url =
    params.startDate && params.endDate ? `/rois/opened-widget?${query}` : null;

  const { data, error, isValidating, mutate } = useSWR(
    url && headerClinicId ? [url, clinicIds] : null,
    async (...resource) => {
      const [url] = resource;
      const response = await axiosInstance.get<RoiOpenedWidgetData>(url, {
        params: { clinicIds },
        headers: { 'X-ClinicId': headerClinicId },
      });
      return response.data;
    }
  );

  if (!params.startDate || !params.endDate) {
    return {
      data: null,
      error: undefined,
      isLoading: false,
      isValidating: false,
      mutate: async () => {},
    };
  }

  return {
    data,
    error,
    isLoading: !data && !error,
    isValidating,
    mutate,
  };
};

export default useRoiOpenedWidget;
